import Button from "@pathwright/ui/src/components/button/Button"
import { useTranslate } from "@pathwright/ui/src/components/lng/withTranslate"
import get from "lodash/get"
import { useEffect, useState } from "react"
import { useManageMentorGroupMembershipsQuery } from "../../api/generated"
import { usePathwrightContext } from "../../pathwright/PathwrightContext"
import { canAdministrate, canViewMentorGroups } from "../../user/permissions"

const ManageMembers = () => {
  const { t } = useTranslate()

  return (
    <Button
      to="/community/members/"
      icon="people"
      label={t("Manage")}
      styleType="primary"
    />
  )
}

const ManageMentorGroups = () => {
  const { t } = useTranslate()
  const [groupId, setGroupId] = useState()
  const query = useManageMentorGroupMembershipsQuery()

  const total = get(query.data, "me.mentorGroupMemberships.total")

  // Check if the user has only 1, admin membership and if so,
  // link directly to the related mentor group.
  useEffect(() => {
    if (total === 1) {
      const cgm = query.data.me.mentorGroupMemberships.edges[0].node
      if (cgm.role === 15) {
        setGroupId(cgm.group_id)
      }
    }
  }, [total])

  const pathname = groupId
    ? `/community/groups/${groupId}/`
    : "/community/groups/"

  return total >= 1 ? (
    <Button
      to={pathname}
      icon="people"
      label={t("Manage")}
      styleType="primary"
    />
  ) : null
}

const ManageNavItem = () => {
  const pwContext = usePathwrightContext()

  if (canAdministrate(pwContext)) {
    return <ManageMembers />
  }

  if (canViewMentorGroups(pwContext)) {
    return <ManageMentorGroups />
  }

  return null
}

export default ManageNavItem
